import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { SearchModel, SearchResultModel } from 'src/common/components';
import { InternalUserViewModel } from './internalusers.model';

@Injectable()
export class InternalUsersService {

    constructor(private http: HttpClient) { }

    search(search: SearchModel): Promise<SearchResultModel<InternalUserViewModel>> {
        return this.http.post<SearchResultModel<InternalUserViewModel>>(`${environment.apiUrl}/InternalUser/search`, search).toPromise();
    }



    save(model: InternalUserViewModel):Promise<InternalUserViewModel>
      {
        return this.http.post<InternalUserViewModel>(`${environment.apiUrl}/InternalUser/Save`, model).toPromise();
      }

      getById(id: number): Promise<InternalUserViewModel> {
          return this.http.get<InternalUserViewModel>(`${environment.apiUrl}/InternalUser/getById/${id}`).toPromise();
    }


}
